import { Box, TextField, Autocomplete, IconButton, Stack } from '@mui/material';
import theme from '../../theme';
import { Search, Close } from '@mui/icons-material';
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../../stores/userStore';
import { trackSearch } from '../../lib/gaEvents';

const MobileSearchBar = ({ onClose, autoFocus = false, pageType }) => {
  const [searchValue, setSearchValue] = useState('');
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    if (autoFocus) {
      // 사이드바 transition(300ms) 이후 실제 input으로 포커스 이전
      const timer = setTimeout(() => {
        inputRef.current?.focus({ preventScroll: true });
      }, 350);
      return () => clearTimeout(timer);
    }
  }, [autoFocus]);

  const handleSearch = (e) => {
    e.preventDefault();
    const trimmed = searchValue.trim();
    if (trimmed) {
      trackSearch({ searchTerm: trimmed, pageType }, user);
      navigate(`/search/summary?q=${encodeURIComponent(trimmed)}`);
      setSearchValue('');
      onClose();
      // Blur the active element to hide the keyboard
      if (document.activeElement) {
        document.activeElement.blur();
      }
    }
  };

  const handleClickClose = (e) => {
    setSearchValue('');
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch(e);
    }
  };

  return (
    <Box
      sx={{
        width: '80vw',
        height: 56,
        backgroundColor: theme.palette.surface.main,
        borderBottom: `1px solid ${theme.palette.grey.line}`,
        display: 'flex',
        alignItems: 'center',
        px: 2.5,
        py: 1,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ width: '100%' }}>
        <Autocomplete
          freeSolo
          fullWidth
          options={[]}
          inputValue={searchValue}
          onInputChange={(_, newInputValue) => {
            setSearchValue(newInputValue);
          }}
          onSubmit={handleSearch}
          renderInput={(params) => (
            <TextField
              {...params}
              inputRef={inputRef}
              placeholder="앨범, 아티스트 등 검색"
              variant="outlined"
              size="small"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <Search sx={{ width: 16, height: 16, color: theme.palette.black[1] }} />
                ),
                endAdornment: null,
                sx: {
                  fontSize: '14px',
                  color: theme.palette.black[8],
                },
                onKeyPress: handleKeyPress,
              }}
            />
          )}
        />
        <IconButton size="small" sx={{ p: 0.5 }} onClick={handleClickClose}>
          <Close sx={{ width: 16, height: 16, color: theme.palette.black[1] }} />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default MobileSearchBar;
